import React from 'react'
import Loader from '../../shared/Loader';
export default function TikTokImages({ selectImage, postData, selectedPosts, loadMorePosts, isLoading, hasError, serviceItem, serviceType }) {
  return (
    <div className="py-5 px-40 border border-gray-350 rounded-3xl">
      <p className="my-10 text-center"><span className="font-semibold">{selectedPosts.length} posts</span> selected <span className="font-semibold">/ {serviceItem[0]?.name}</span> per post</p>
      <div className="grid grid-cols-4 gap-3">
        {postData && postData.map((post, idx) => (
          <button key={idx} className="hover:opacity-80 transition-all">
            <img onClick={(e) => selectImage(e.target, JSON.parse(localStorage.getItem("TikTokData")), serviceType)} id={post?.statistics?.aweme_id} data-code={post?.statistics?.aweme_id} data-url={post?.video?.dynamic_cover?.url_list[0]} className={selectedPosts.find(el => el == post?.statistics?.aweme_id) !== undefined ? 'shadow-2xl brightness-125 border-4 border-blue-500' : ""} src={post?.video?.dynamic_cover?.url_list[0]} alt="Post" />
          </button>
        ))}
      </div>
      <div className={`flex flex-row ${isLoading ? 'justify-center' : hasError ? 'justify-between' : 'justify-center'}`}>
        {isLoading ?
          (<div className="my-5 mx-20"> <Loader styles={"w-12 h-12"}></Loader> </div>) :
          hasError ? ((<p className="my-10 text-xl text-red-600">Failed loading, please try again!</p>)) : null}
        {!isLoading ? ((<button className="my-10 px-8 py-1 uppercase rounded-3xl border-2 border-pink-350 hover:text-pink-350 transition-all" type="button" value="Load More Posts" onClick={loadMorePosts}>Load More Posts</button>)) : null}
      </div>
    </div>
  )
}
